// Attribute contract shared with the React bindings and the story CSS.
/** On draggables; the value is the kit id. */
export const DND_DRAGGABLE_ATTR = 'data-astra-draggable'
export const DND_DRAG_HANDLE_ATTR = 'data-astra-drag-handle'
/** On droppables; the value is the kit id. */
export const DND_DROPPABLE_ATTR = 'data-astra-droppable'
/** Optional id of a droppable, reported back as dropId. */
export const DND_DROP_ID_ATTR = 'data-astra-drop-id'
/** On Zone wrappers; the value is the kit id. */
export const DND_ZONE_ATTR = 'data-astra-dnd-zone'
export const DND_DROP_TARGET_ATTR = 'data-astra-drop-target'
export const DND_DROP_VALID_ATTR = 'data-astra-drop-valid'
/** Pointer insertion half on the active droppable (`before` | `after`). Only on valid targets other than the dragged element; cleared on leave. */
export const DND_DROP_EDGE_ATTR = 'data-astra-drop-edge'
export const DND_DRAGGING_ATTR = 'data-astra-dragging'

// Owned by the engine's keyboard path: the single aria-live announcer plus the
// static lift/move/drop instructions the bindings reference via aria-describedby.
export const DND_LIVE_REGION_ID = 'astra-dnd-live-region'
export const DND_KEYBOARD_INSTRUCTIONS_ID = 'astra-dnd-keyboard-instructions'
